(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summer-product"] && !Shopify.designMode) return;
  try {
    
function initializeSharingPackage(root) {
  if (!root || root.dataset.scSharingReady === 'true') return;
  const select = root.querySelector('[data-sc-package-select]');
  const mainImage = root.querySelector('[data-sc-main-image]');
  const imageLabel = root.querySelector('[data-sc-image-label]');
  const price = root.querySelector('[data-sc-selected-price]');
  const thumbs = Array.from(root.querySelectorAll('[data-sc-package-thumb]'));
  const copies = Array.from(root.querySelectorAll('[data-sc-package-copy]'));
  if (!select || !mainImage) return;
  root.dataset.scSharingReady = 'true';
  const showImage = (thumb) => {
    if (!thumb) return;
    mainImage.src = thumb.dataset.src;
    mainImage.alt = thumb.dataset.alt;
    if (imageLabel) imageLabel.textContent = thumb.dataset.label;
    thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
  };
  const updatePackage = () => {
    const option = select.options[select.selectedIndex];
    const packageKey = option.dataset.package;
    thumbs.forEach((thumb) => { thumb.hidden = thumb.dataset.scPackageThumb !== packageKey; });
    copies.forEach((copy) => { copy.hidden = copy.dataset.scPackageCopy !== packageKey; });
    if (price) price.textContent = option.dataset.price;
    showImage(thumbs.find((thumb) => thumb.dataset.scPackageThumb === packageKey));
  };
  select.addEventListener('change', updatePackage);
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showImage(thumb)));
  updatePackage();
}
document.querySelectorAll('.sc-sharing-product').forEach(initializeSharingPackage);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.sc-sharing-product').forEach(initializeSharingPackage);
});

  } catch(e) { console.error(e); }
})();
})();
